
      (async () => {
        try {
          await import('/src/entry-client.ts');
        } catch (error) {
          // If module loading throws Error from some part of the
          // code Safari does not show the error inside console
          // when loading is done traditionally i.e. <script type="module" src="src/entry-client.ts" />
          console.error('Error loading client module:', error);
        }
      })();
    